"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiFetch = apiFetch;
const config_1 = require("../config");
const AUTH_REDIRECT_URL = process.env.AUTH_APP_REDIRECT_URL || "https://dev.crm.auth.marktine.com/login";
const getCommonHeaders = () => {
    const userDetails = (0, config_1.getUserDetails)();
    return {
        "Content-Type": "application/json",
        "X-Org-Id": userDetails.group_id,
        "X-User-Id": userDetails.id,
        Authorization: `Bearer ${(0, config_1.getAuthToken)()}`,
    };
};
function apiFetch(endpoint_1) {
    return __awaiter(this, arguments, void 0, function* (endpoint, options = {}) {
        var _a, _b, _c, _d, _e, _f;
        try {
            const response = yield fetch(endpoint, Object.assign({ 
                //   credentials: 'include', // Needed for cookies
                headers: Object.assign(Object.assign({}, getCommonHeaders()), options.headers) }, options));
            if (response.status === 401) {
                // Clear session/local storage if needed
                localStorage.removeItem("user");
                sessionStorage.removeItem("user");
                // Optional: log or alert
                console.warn("Session expired. Redirecting to login.");
                // Redirect to login page
                if (AUTH_REDIRECT_URL) {
                    const currentUrl = encodeURIComponent(window.location.href);
                    window.location.href = `${AUTH_REDIRECT_URL}?redirect_to=${currentUrl}`;
                }
                return Promise.reject("Unauthorized"); // or return void
            }
            if (!response.ok) {
                const errorData = yield response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error! Status: ${response.status}`);
            }
            // For file downloads, return the response directly
            if (((_b = (_a = options.headers) === null || _a === void 0 ? void 0 : _a['Accept']) === null || _b === void 0 ? void 0 : _b.includes('application/octet-stream')) ||
                ((_c = response.headers.get('content-type')) === null || _c === void 0 ? void 0 : _c.includes('application/octet-stream')) ||
                ((_d = response.headers.get('content-type')) === null || _d === void 0 ? void 0 : _d.includes('application/pdf')) ||
                ((_e = response.headers.get('content-type')) === null || _e === void 0 ? void 0 : _e.includes('application/vnd.openxmlformats')) ||
                ((_f = response.headers.get('content-type')) === null || _f === void 0 ? void 0 : _f.includes('application/msword'))) {
                return response;
            }
            // Try to parse JSON, but handle empty responses gracefully
            try {
                const text = yield response.text();
                if (!text.trim()) {
                    // Empty response, return undefined for void operations
                    return undefined;
                }
                return JSON.parse(text);
            }
            catch (parseError) {
                // If JSON parsing fails, return undefined for void operations
                return undefined;
            }
        }
        catch (error) {
            console.error("API Fetch Error:", error);
            throw error;
        }
    });
}
